import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import {
  TaskSupplierScheduleStepStore,
  TaskSupplierScheduleStore,
} from '../../../task-supplier-schedule/task-supplier-schedule-store';
import { EventService, IJobScreenEvent, JobsService } from '../../../../services';
import { JobSupplierScheduleContext } from '../../../task-supplier-schedule/task-supplier-schedule';
import { Subscription } from 'rxjs';
import {
  DriverScheduleUpdateTypeEnum,
  DriverScheduleUpdateTypeLabels,
} from '../../../../enums/driver-schedule-update-type-enum';

interface Step {
  name: string;
  schedule: TaskSupplierScheduleStepStore;
}

@Component({
  selector: 'job-screen-supplier-schedule',
  templateUrl: './job-screen-supplier-schedule.component.html',
  styleUrls: ['./job-screen-supplier-schedule.component.scss'],
})
export class JobScreenSupplierScheduleComponent implements OnInit, OnDestroy {
  @Input() jobId: number;

  @Input() taskId: number;
  subscriptions: Subscription[] = [];

  public scheduleContext: JobSupplierScheduleContext;

  constructor(private jobService: JobsService, private eventService: EventService) {}

  async getScheduleContext(jobId: number) {
    this.scheduleContext = await this.jobService.getUpdateSupplierScheduleContext(jobId);
  }

  private updateTask() {
    const task = this.scheduleContext.tasks.find((x) => x.id == this.taskId);

    this.taskSupplierScheduleStore = new TaskSupplierScheduleStore(task, []);
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.jobId?.currentValue) {
      await this.getScheduleContext(changes.jobId?.currentValue);
    }

    if (this.scheduleContext && changes.taskId.currentValue) {
      this.updateTask();
    }
  }

  public taskSupplierScheduleStore: TaskSupplierScheduleStore;

  @Input() hideDropOff: Boolean = false;

  public get pickUp(): TaskSupplierScheduleStepStore {
    return this.taskSupplierScheduleStore.pickUp;
  }

  public get task() {
    return this.taskSupplierScheduleStore.task;
  }

  public get dropOff(): TaskSupplierScheduleStepStore {
    return this.taskSupplierScheduleStore.dropOff;
  }

  public get hasSchedule(): boolean {
    return !this.pickUp.isDefault;
  }

  ngOnInit() {
    this.subscriptions.push(
      this.eventService.JobScreenEvent.subscribe((event) => {
        void this.handleEvents(event);
      }),
    );
  }

  private async handleEvents(event: IJobScreenEvent) {
    if (event.event == 'refresh-schedule' && this.jobId && this.taskId) {
      await this.getScheduleContext(this.jobId);
      this.updateTask();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x?.unsubscribe());
  }

  protected readonly DriverScheduleUpdateTypeLabels = DriverScheduleUpdateTypeLabels;
  protected readonly DriverScheduleUpdateTypeEnum = DriverScheduleUpdateTypeEnum;
}
